import { useMatch } from 'react-router-dom';

import { AppRoute } from '../app/routes';
import { type AdsPlacementsType } from '../types/ads';

const useAdsPlacement = (): AdsPlacementsType => {
  const isFactory = useMatch(AppRoute.FACTORY + '/:id');
  const isWorkshop = useMatch(AppRoute.WORKSHOP + '/:id');

  if (isFactory) {
    return 'material';
  }

  if (isWorkshop) {
    return 'goods';
  } else {
    return 'resource';
  }
};

export { useAdsPlacement };
